import { render, staticRenderFns } from "./PublishDateStatus.vue?vue&type=template&id=2f89281c&lang=pug&"
import script from "./PublishDateStatus.vue?vue&type=script&lang=js&"
export * from "./PublishDateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports